import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanDeactivate,
} from '@angular/router';
import { SelectedJobInfoComponent } from '../../jobs-module/components/selected-job-info/selected-job-info.component';
import { first } from 'rxjs/operators';
import { ViewJobPageComponent } from '../../jobs-module/containers/view-job-page.component';

@Injectable()
export class JobPostCanDeactivateGuard
  implements CanDeactivate<ViewJobPageComponent> {
  private discardSubject: Subject<boolean> = new Subject<boolean>();

  discard(): void {
    console.log('discard');
    this.discardSubject.next(true);
  }

  keep(): void {
    console.log('keep');
    this.discardSubject.next(false);
  }

  canDeactivate(
    component: ViewJobPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (!component.isJobSaved) {
      component.openDiscardChangesModal();
      return this.discardSubject.asObservable().pipe(first());
    }

    return true;
  }
}
